import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onRequestAccess", "isContactEnrichment"],
  _excluded2 = ["onRequestAccess", "isContactEnrichment", "maxInlineSize"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Body, LayoutHorizontal, Modal, EmptyState } from 'breeze-intelligence-kit';
import { LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { NoAccessPanelEmptyState } from '../NoAccess/NoAccessPanelEmptyState';
import { MAX_INLINE_SIZE } from '../NoAccess/constants';
import { NoAccessModalEmptyState, NoAccessModalEmptyStateHeader } from '../NoAccess/NoAccessModalEmptyState';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrichmentNoAccessManual = ({
  isContactEnrichment,
  maxInlineSize = MAX_INLINE_SIZE
}) => {
  const {
    companyLabelLowercase,
    contactLabelLowercase
  } = useEnrichableObjectTypes();
  return /*#__PURE__*/_jsx(LayoutHorizontal, {
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(LayoutSpaceVertical, {
      maxInlineSize: maxInlineSize,
      children: /*#__PURE__*/_jsxs(Body, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.permissions.noAccessManual",
          options: {
            objectType: isContactEnrichment ? contactLabelLowercase : companyLabelLowercase
          }
        }), ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentProperties.permissions.noAccessManualContactAdmin"
        })]
      })
    })
  });
};
export const EnrichmentNoAccessManualModal = _ref => {
  let {
      onRequestAccess,
      isContactEnrichment
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NoAccessModalEmptyStateHeader, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.permissions.noAccessTitle"
      })
    }), /*#__PURE__*/_jsx(NoAccessModalEmptyState, Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(EnrichmentNoAccessManual, {
        isContactEnrichment: isContactEnrichment,
        onRequestAccess: onRequestAccess
      })
    })), /*#__PURE__*/_jsx(Modal.Footer, {})]
  });
};
export const EnrichmentNoAccessManualPanel = _ref2 => {
  let {
      onRequestAccess,
      isContactEnrichment,
      maxInlineSize
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(NoAccessPanelEmptyState, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(EmptyState.Title, {
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "enrichmentProperties.permissions.noAccessTitle"
      })
    }), /*#__PURE__*/_jsx(EnrichmentNoAccessManual, {
      isContactEnrichment: isContactEnrichment,
      maxInlineSize: maxInlineSize,
      onRequestAccess: onRequestAccess
    })]
  }));
};